import React, { useState } from 'react';
import Icon from 'components/AppIcon';
import { Form, Input, Select, Checkbox, Alert } from 'antd';

const LANGUAGES = [
  { id: 1, code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { id: 2, code: 'en', name: 'English', flag: '🇺🇸' }
];

const PersonalInformationStep = ({ formData, updateFormData }) => {
  const [errors, setErrors] = useState({});

  const validateName = (name) => {
    return name.length >= 2 && /^[a-zA-Zа-яА-ЯёЁ\s\-']+$/.test(name);
  };

  const handleInputChange = (field, value) => {
    updateFormData({ [field]: value });
    
    // Clear errors when user starts typing
    if (errors[field]) {
      setErrors(prev => ({ ...prev, [field]: '' }));
    }

    // Real-time validation
    if (field === 'name' && value && !validateName(value)) {
      setErrors(prev => ({ ...prev, name: 'Имя должно содержать только буквы и быть не менее 2 символов' }));
    }

    if (field === 'surname' && value && !validateName(value)) {
      setErrors(prev => ({ ...prev, surname: 'Фамилия должна содержать только буквы и быть не менее 2 символов' }));
    }
  };

  return (
    <Form layout="vertical" className="space-y-6">
      <div className="text-center mb-6">
        <h3 className="text-lg font-semibold text-text-primary mb-2">
          Личная информация
        </h3>
        <p className="text-text-secondary">
          Заполните персональные данные для завершения регистрации
        </p>
      </div>

      {/* Name Fields Row */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {/* Name (First Name) */}
        <Form.Item
          label="Имя *"
          validateStatus={errors.name ? 'error' : undefined}
          help={errors.name}
          className="mb-0"
        >
          <Input
            size="large"
            value={formData.name}
            onChange={(e) => handleInputChange('name', e.target.value)}
            placeholder="Иван"
            suffix={<Icon name="User" size={16} className={errors.name ? 'text-error' : 'text-secondary-400'} />}
          />
        </Form.Item>

        {/* Surname (Last Name) */}
        <Form.Item
          label="Фамилия *"
          validateStatus={errors.surname ? 'error' : undefined}
          help={errors.surname}
          className="mb-0"
        >
          <Input
            size="large"
            value={formData.surname}
            onChange={(e) => handleInputChange('surname', e.target.value)}
            placeholder="Иванов"
            suffix={<Icon name="User" size={16} className={errors.surname ? 'text-error' : 'text-secondary-400'} />}
          />
        </Form.Item>
      </div>

      {/* Preferred Language */}
      <Form.Item label="Предпочитаемый язык" help="Выберите язык интерфейса системы">
        <Select
          size="large"
          value={formData.langId}
          onChange={(value) => handleInputChange('langId', value)}
          options={LANGUAGES.map(lang => ({ label: `${lang.flag} ${lang.name}`, value: lang.id }))}
        />
      </Form.Item>

      {/* Additional Information */}
      <Alert
        type="info"
        showIcon
        icon={<Icon name="Shield" size={20} className="text-accent" />}
        message="Безопасность данных"
        description="Все персональные данные шифруются и хранятся в соответствии с требованиями безопасности. Ваша информация не будет передана третьим лицам без вашего согласия."
      />

      {/* Data Processing Consent */}
      <Form.Item className="mb-0">
        <Checkbox
          checked={formData.dataProcessingConsent || false}
          onChange={(e) => updateFormData({ dataProcessingConsent: e.target.checked })}
        >
          Я согласен на обработку персональных данных в соответствии с{' '}
          <a href="/privacy" target="_blank" rel="noopener noreferrer" className="text-primary hover:text-primary-700 underline">
            Политикой конфиденциальности
          </a>
        </Checkbox>
      </Form.Item>
    </Form>
  );
};

export default PersonalInformationStep;